import { connect } from 'react-redux';
import ViewDailyTaskDetails from './viewDailyTaskDetails';
import { bindActionCreators } from 'redux';
import { getSiteStage,siteStageStatus,siteUnhold,siteDismantle,saveSiteIssues,getIssuesList } from 'services/redux/installation/siteStages/action';
import { getCurrentLocation } from 'services/redux/sales/currentLocation/action';
import {
  getCheckLocation
} from "services/redux/installation/siteInspection/action";
import {getSiteData, calculateDistance, getDistanceDataDailyTaskAtt, getDistanceData} from "../../../services/redux/DistanceCalculator/action";
import { getSiteVisitList, rmCheckOutRequest } from 'services/redux/networkEngineer/action';
import siteStageReducer from "../../../services/redux/installation/siteStages/reducer";

const mapStateToProps = (state) => ({
  siteStageData: state.siteStageReducer.siteStageData.site_stages,
  siteDetails: state.siteStageReducer.siteStageData.site_details,
  isVendorAllocated: state.siteStageReducer.siteStageData.is_vendor_allocated,
  is_asset_mapping: state.siteStageReducer.siteStageData.is_asset_mapping,
  locationCheck : state.siteInspectionReducer.locationCheck,
  userProfile : state.loginReducer.userProfile,
  siteData: state.leadDataReducer.siteData,
  dailyDistance: state.leadDataReducer.dailyDistance,
  distanceDetails: state.leadDataReducer.distanceDetails,
  engDistanceData: state.leadDataReducer.engDistanceData,
  issuesList: state.siteStageReducer.siteIssuesList,
  rmCheckOutResponse: state.NetEnggReducer.rmCheckOutResponse,

});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getSiteStage,
      siteStageStatus,
      siteUnhold,
      siteDismantle,
      // getCurrentLocation,
      getCheckLocation,
      getSiteData,
      calculateDistance,
      getDistanceDataDailyTaskAtt,
      getDistanceData,
      saveSiteIssues,
      getIssuesList,
      rmCheckOutRequest,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ViewDailyTaskDetails);
